import { distance, closest } from "fastest-levenshtein";
import { Store } from "../interfaces/IStore";
const addPadding = (str: string, len: number) => {
  const paddingLen = str.length < len ? (len - str.length) : 0;
  let padding = "";
  for (let x = 0; x < paddingLen; x++) {
    padding = padding + "z";
  }
  return str + padding;
}
export const levenSort = (query: string, stores: Store[]) => {
  const lang = window.data?.language || "en";
  const padding = stores.map(s => (s[`name_${lang}`] || s.name_en).toLowerCase()).reduce((a, b) => Math.max(a, b.length), 0);
  const q = query.toLowerCase();
  const closestMatch = stores.sort((a, b) => {
    let aDistance = Number.POSITIVE_INFINITY;
    let bDistance = Number.POSITIVE_INFINITY;
    const aName: string = addPadding((a[`name_${lang}`] || a.name_en).toLowerCase(), padding)
    const bName: string = addPadding((b[`name_${lang}`] || b.name_en).toLowerCase(), padding);
    //qArray.forEach(q => {
    aDistance = Math.min(aDistance, distance(q, aName));
    bDistance = Math.min(bDistance, distance(q, bName));
    //})
    return aDistance - bDistance;
  }).sort((a,b) => {
    if((a[`name_${lang}`] || a.name_en).toLowerCase().includes(q) && (b[`name_${lang}`] || b.name_en).toLowerCase().includes(q)) return 0;
    else if((a[`name_${lang}`] || a.name_en).toLowerCase().includes(q)) return -1;
    else return 1;
  });
  if((closestMatch[0][`name_${lang}`] || closestMatch[0].name_en).toLowerCase().includes(q)) return {lat:closestMatch[0].latitude,lng:closestMatch[0].longitude};
  else return false;
};